import { useActivitiesContext } from '../../../context'
import { useMemo } from 'react'
import { ActivityDetails } from '../../ActivityDetails'
import { ActivityForm } from '../../ActivityForm'
import { ActivitiesList } from '../../ActivitiesList'

export function useData() {
  const [{ contentOpened, popoverEl, content }] = useActivitiesContext()
  const Content = useMemo(() => {
    switch (content) {
      case 'details':
        return ActivityDetails
      case 'form':
        return ActivityForm
      default:
        return ActivitiesList
    }
  }, [content])

  return {
    Content,
    contentOpened,
    popoverEl,
  }
}
